// extracted by mini-css-extract-plugin
export default {"fileBox":"CsvUpload_fileBox__tr2no","btn":"CsvUpload_btn__ndgex","type01":"CsvUpload_type01__VgH2n"};